module.exports = __webpack_public_path__ + "img/jstx.a5ecc183.svg";